let $productHelper;
let $petClubPrice;
let $subPrice;
let $firstSubOfferPrice;
let $subDiscount;
let $firstSubOfferDiscount;
let $firstSubOfferWidget;
let productID = false;
let rechargeLoaded = false;

function cacheDOM() {
  $productHelper = document.querySelector('.js-product-helper');
  $petClubPrice = document.querySelector('.js-pet-club-price-trigger');
  $subPrice = document.querySelector('.sub-promo__normal-sub-price');
  $subDiscount = document.querySelector('.sub-promo__sub_discount');
  $firstSubOfferPrice = document.querySelector('.sub-promo__first-sub-price');
  $firstSubOfferDiscount = document.querySelector('.sub-promo__offer_discount');
  $firstSubOfferWidget = document.querySelector('.sub-promo');
}

function getActivePrice() {
  let price = false;
  // Get loaded widget
  const widget = window.Recharge.widgets[productID];
  if (!widget) return false;

  // Get the selected variant ID
  const selectedVariantID = parseInt(widget?.state?.variant, 10);
  if (!selectedVariantID) return false;

  if (!widget?.product?.variants) {
    return false;
  }

  // Find the variant with the selected ID
  // eslint-disable-next-line max-len
  const variantDetails = widget.product.variants.find((variant) => variant.id === selectedVariantID);
  if (!variantDetails) return false;

  // Get the price to display
  if (widget?.state?.sellingPlan) {
    price = variantDetails?.prices?.discounted_price ?? false;
  } else {
    price = variantDetails?.prices?.unit_price ?? false;
  }

  return price;
}

function getFullPrice() {
  // const price = false;

  // Get loaded widget
  const widget = window.Recharge.widgets[productID];
  if (!widget) return false;

  // Get the selected variant ID
  const selectedVariantID = parseInt(widget?.state?.variant, 10);
  if (!selectedVariantID) return false;

  if (!widget?.product?.variants) {
    return false;
  }

  // Find the variant with the selected ID
  // eslint-disable-next-line max-len
  const variantDetails = widget.product.variants.find((variant) => variant.id === selectedVariantID);
  if (!variantDetails) return false;

  // Get the price to display
  return variantDetails?.prices?.unit_price ?? false;
}

function getSubPrice() {
  // const price = false;

  // Get loaded widget
  const widget = window.Recharge.widgets[productID];
  if (!widget) return false;

  // Get the selected variant ID
  const selectedVariantID = parseInt(widget?.state?.variant, 10);
  if (!selectedVariantID) return false;

  if (!widget?.product?.variants) {
    return false;
  }

  // Find the variant with the selected ID
  // eslint-disable-next-line max-len
  const variantDetails = widget.product.variants.find((variant) => variant.id === selectedVariantID);
  if (!variantDetails) return false;

  // Get the price to display
  if (widget?.state?.sellingPlan) {
    return variantDetails?.prices?.discounted_price ?? false;
  }

  return false;
}

function getFirstSubOfferPrice() {
  const subPrice = getSubPrice();

  return subPrice * 0.82;
}

function updatePetClubPrice() {
  const price = getActivePrice();
  if (price) {
    $petClubPrice.innerText = price;
  }
}

function updateFirstSubOfferPrice() {
  const subPrice = getSubPrice();
  const offerPrice = getFirstSubOfferPrice();
  const fullPrice = getFullPrice();
  console.log('full price:', fullPrice);
  if (subPrice && offerPrice) {
    $subPrice.innerHTML = `&pound;${(Math.round(subPrice * 100) / 100).toFixed(2)}`;
    $firstSubOfferPrice.innerHTML = `&pound;${(Math.round(offerPrice * 100) / 100).toFixed(2)}`;

    $subDiscount.innerHTML = Math.round((((fullPrice - subPrice) / fullPrice)) * 100);
    $firstSubOfferDiscount.innerHTML = Math.round((((fullPrice - offerPrice) / fullPrice)) * 100);

    $firstSubOfferWidget.style.display = 'block';
  }
}

function getPlanState() {
  let planState = false;

  // Get loaded widget
  const widget = window.Recharge.widgets[productID];
  if (!widget) return false;

  // Get the selected variant ID
  const selectedVariantID = parseInt(widget?.state?.variant, 10);
  if (!selectedVariantID) return false;

  if (!widget?.product?.variants) {
    return false;
  }

  // See if it's a one time or subscription plan
  if (widget?.state?.sellingPlan) {
    planState = 'subscription';
  } else {
    planState = 'one-time';
  }
  return planState;
}

function toggleElements() {
  const $elements = document.querySelectorAll('[data-show-plan]');
  const planState = getPlanState();
  if (!$elements) return;

  $elements.forEach(($element) => {
    const elementShowTarget = $element.dataset.showPlan ?? false;
    if (elementShowTarget === false || elementShowTarget === 'both') {
      $element.classList.remove('hidden');
    } else if (elementShowTarget === planState) {
      $element.classList.remove('hidden');
    } else {
      $element.classList.add('hidden');
    }
  });
}

function onRechargePlanChange() {
  updatePetClubPrice();
  updateFirstSubOfferPrice();
  toggleElements();
}

function initHelper() {
  if (window?.Recharge?.eventService?.listeners) {
    const rechargeEventNames = Object.keys(window.Recharge.eventService.listeners);
    if (rechargeEventNames && rechargeEventNames.length) {
      window.Recharge.eventService.addEventListener(rechargeEventNames[0], onRechargePlanChange);
      // Trigger on init
      setTimeout(onRechargePlanChange, 500);
    }
  }
}

function checkRechargeLoaded() {
  if (rechargeLoaded) return;
  if (window.Recharge) {
    rechargeLoaded = true;
    initHelper();
  } else {
    setTimeout(checkRechargeLoaded, 300);
  }
}

function getProductID() {
  productID = $productHelper?.dataset?.productId ?? false;
}

export default function init() {
  cacheDOM();
  if (
    $productHelper
    && $petClubPrice
    && $subPrice
    && $subDiscount
    && $firstSubOfferPrice
    && $firstSubOfferDiscount) {
    getProductID();
    checkRechargeLoaded();
  }
}
